// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-template-wrapper {
  height: 100%;
  padding: 8px;
  width: 100%;
}
.transcript-template-wrapper .transcript-template-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--AA-gloabl-border);
  border-radius: 4px;
}
.transcript-template-wrapper .transcript-template-data .transcript-header {
  padding: 7px 11px;
  border-radius: 4px 4px 0px 0px;
  border-bottom: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
}
.transcript-template-wrapper .transcript-template-data .transcript-body-wrapper {
  flex: 1 1 auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px 11px;
  gap: 12px;
}

.aa-agent-bubble-comp {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.aa-agent-bubble-comp .agent-bubble-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 6px;
  max-width: 90%;
  transition: 0.5s all ease;
  word-break: break-word;
}
.aa-agent-bubble-comp .agent-bubble-content .top-info {
  display: flex;
  align-items: center;
  gap: 4px;
}
.aa-agent-bubble-comp .agent-bubble-content .top-info .time-tamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--AA-gloabl-text-color);
}
.aa-agent-bubble-comp .agent-bubble-content .top-info .you-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--AA-gloabl-text-color);
}
.aa-agent-bubble-comp .agent-bubble-content .bubble-msg {
  background: var(--AA-global-theme-bg);
  border-radius: 8px 8px 2px 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--AA-global-white-color);
  padding: 8px 12px;
}

.aa-bot-bubble-comp {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
.aa-bot-bubble-comp .bot-bubble-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 90%;
  justify-content: flex-start;
  align-items: flex-start;
  transition: 0.5s all ease;
  word-break: break-word;
  gap: 6px;
}
.aa-bot-bubble-comp .bot-bubble-content .top-info {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.aa-bot-bubble-comp .bot-bubble-content .top-info .time-tamp {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--AA-gloabl-text-color);
  flex-shrink: 0;
}
.aa-bot-bubble-comp .bot-bubble-content .top-info .you-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--AA-gloabl-text-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.aa-bot-bubble-comp .bot-bubble-content .bubble-msg-with-img {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0;
  position: relative;
  gap: 6px;
}
.aa-bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .bubble-msg {
  background: var(--AA-gloabl-bg-secondary);
  border-radius: 8px 8px 2px 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--AA-gloabl-text-color);
  padding: 8px 12px;
  word-break: break-word;
  white-space: break-spaces;
}
.aa-bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .intent-suggestion-buld {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}
.aa-bot-bubble-comp .bot-bubble-content .bubble-msg-with-img .intent-suggestion-buld sub {
  position: absolute;
  top: -2px;
  right: 0;
  display: flex;
  width: 12px;
  height: 12px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background: #D92D20;
  color: var(--AA-global-white-color);
  font-size: 7px;
  font-weight: 500;
  line-height: 0;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.agent-joined-banner {
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}
.agent-joined-banner .line-border {
  width: 100%;
  border-top: 1px solid var(--AA-gloabl-border);
}
.agent-joined-banner .info-joined-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.summary-wrapper {
  border-radius: 8px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-gloabl-bg-secondary);
  display: inline-flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  flex-direction: column;
  width: auto;
  margin: 10px auto;
  gap: 6px;
}
.summary-wrapper .summary-header {
  display: flex;
  align-items: center;
  gap: 6px;
}
.summary-wrapper .summary-header svg path {
  fill: var(--AA-gloabl-text-color);
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/transcript/transcript.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,YAAA;EACA,WAAA;AADJ;AAEI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;AAAR;AACQ;EACI,iBAAA;EACA,8BAAA;EACA,gDAAA;EACA,qCAAA;AACZ;AACQ;EACI,cAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AACZ;;AAIA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;AADJ;AAEI;EACI,aAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAAR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AACZ;AAAY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;AAEhB;AAAY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;AAEhB;AACQ;EACI,qCAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,iBAAA;AACZ;;AAIA;EACI,aAAA;EACA,WAAA;EACA,2BAAA;AADJ;AAEI;EACI,aAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,QAAA;AAAR;AAQQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AANZ;AAOY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,cAAA;AALhB;AAOY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AALhB;AAQQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;AANZ;AAOY;EACI,yCAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AALhB;AAOY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AALhB;AAMgB;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;AAJpB;;AAWA;EACI,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AARJ;AASI;EACI,WAAA;EACA,6CAAA;AAPR;AASI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAPR;;AAYA;EACI,kBAAA;EACA,yCAAA;EACA,yCAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,QAAA;AATJ;AAUI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AARR;AAUY;EACI,iCAAA;AARhB","sourcesContent":["\n\n.transcript-template-wrapper{\n    height: 100%;\n    padding: 8px;\n    width: 100%;\n    .transcript-template-data{\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        border: 1px solid var(--AA-gloabl-border);\n        border-radius: 4px;\n        .transcript-header{\n            padding: 7px 11px;\n            border-radius: 4px 4px 0px 0px;\n            border-bottom: 1px solid var(--AA-gloabl-border);\n            background: var(--AA-global-white-bg);\n        }\n        .transcript-body-wrapper{\n            flex: 1 1 auto;\n            overflow: auto;\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            padding: 12px 11px;\n            gap: 12px;\n        }\n    }\n}\n\n.aa-agent-bubble-comp{\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    .agent-bubble-content{\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: flex-end;\n        gap: 6px;\n        max-width: 90%;\n        transition: 0.5s all ease;\n        word-break: break-word;\n        .top-info{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            .time-tamp{\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--AA-gloabl-text-color);\n            }\n            .you-text{\n                font-weight: 600;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--AA-gloabl-text-color);\n            }\n        }\n        .bubble-msg{\n            background:var(--AA-global-theme-bg);\n            border-radius: 8px 8px 2px 8px;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 18px;\n            color: var(--AA-global-white-color);\n            padding: 8px 12px;\n        }\n    }\n}\n\n.aa-bot-bubble-comp{\n    display: flex;\n    width: 100%;\n    justify-content: flex-start;\n    .bot-bubble-content{\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        max-width: 90%;\n        justify-content: flex-start;\n        align-items: flex-start;\n        transition: 0.5s all ease;  \n        word-break: break-word;\n        gap: 6px;\n        &:hover{\n            .bubble-msg-with-img{\n                .bubble-msg{\n                    // background-color: var(--backgroundColorMsgNode);\n                }                \n            }\n        }\n        .top-info{\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            width: 100%;\n            .time-tamp{\n                font-weight: 400;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--AA-gloabl-text-color);\n                flex-shrink: 0;\n            }\n            .you-text{\n                font-weight: 600;\n                font-size: 12px;\n                line-height: 15px;\n                color: var(--AA-gloabl-text-color);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n            }\n        }\n        .bubble-msg-with-img{\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin: 2px 0;\n            position: relative;\n            gap: 6px;\n            .bubble-msg{\n                background: var(--AA-gloabl-bg-secondary);\n                border-radius: 8px 8px 2px 8px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 18px;\n                color: var(--AA-gloabl-text-color);\n                padding: 8px 12px;\n                word-break: break-word;\n                white-space: break-spaces;\n            }\n            .intent-suggestion-buld{\n                width: 24px;\n                height: 24px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                position: relative;\n                cursor: pointer;\n                sub{\n                    position: absolute;\n                    top: -2px;\n                    right: 0;\n                    display: flex;\n                    width: 12px;\n                    height: 12px;\n                    padding: 0;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 100px;\n                    background: #D92D20;\n                    color: var(--AA-global-white-color);\n                    font-size: 7px;\n                    font-weight: 500;\n                    line-height: 0;\n                    letter-spacing: 0.5px;\n                    text-transform: uppercase;\n                }\n            }\n        }\n    }\n}\n\n.agent-joined-banner{\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    margin-bottom: 20px;\n    .line-border{\n        width: 100%;\n        border-top: 1px solid var(--AA-gloabl-border);\n    }\n    .info-joined-details{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 2px;\n        flex-shrink: 0;\n    }\n}\n\n\n.summary-wrapper{\n    border-radius: 8px;\n    border: 1px solid var(--AA-gloabl-border);\n    background: var(--AA-gloabl-bg-secondary);\n    display: inline-flex;\n    padding: 12px;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    flex-direction: column;\n    width: auto;\n    margin: 10px auto;\n    gap: 6px;\n    .summary-header{\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        svg{\n            path{\n                fill: var(--AA-gloabl-text-color);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
